module.exports = __webpack_public_path__ + "img/right-arrow.8633bab1.svg";